module.exports = __webpack_public_path__ + "983261c55a13a9d18aa709ebf2468cbb.fbx";